import { AccessListContent } from 'types/Access';
import { isApprovalLimitInvalid, parseBRLToNumber } from 'helpers/currency';

/** valor impossível p/ limite real (>= 0); representa "inativo" na comparação de limite-efetivo */
const LIMIT_SENTINEL = -1;

/** estado editável (local) do limite de UM acesso */
export type LimitEdit = {
	// CurrencyInput emite string mascarada ("1.000,50") ao digitar e number no onBlur;
	// guardamos como emitido e normalizamos com parseBRL onde precisar de número.
	value: string | number;
	active: boolean;
};

/** normaliza o valor do CurrencyInput (string BRL ou number) para number */
export const parseBRL = parseBRLToNumber;

/** limite-efetivo: valor só conta quando ativo; inativo colapsa no sentinel */
const effectiveLimit = (active: boolean, value: string | number): number =>
	active ? parseBRL(value) : LIMIT_SENTINEL;

/** snapshot salvo (vindo da API) como LimitEdit */
export const toLimitEdit = (access: AccessListContent): LimitEdit => ({
	value: access.posting_approval_limit,
	active: access.posting_approval_limit_active,
});

/** o limite mudou em relação ao salvo? (mudar o valor com o limite inativo não conta) */
export const isLimitDirty = (saved: LimitEdit, edit: LimitEdit): boolean =>
	effectiveLimit(saved.active, saved.value) !==
	effectiveLimit(edit.active, edit.value);

/** espelha o superRefine do backend: ativo exige valor > 0 */
export const isLimitInvalid = (edit: LimitEdit): boolean =>
	isApprovalLimitInvalid(edit.active, edit.value);
